export const useFilters = () => {
    const correctETH = (eth) => {
        return /^0x[a-fA-F0-9]{40}$/.test(eth);
    };
    const shortAddress = (address) => {
        return address ? address.substr(0, 5) + "..." + address.substr(-5) : "";
    };
    return {
        correctETH,
        shortAddress
    };
};
